import React from 'react';
import { useConnect } from '@lore/query-connect';
import Tooltip from '../../../_post-opportunity/forms/Tooltip';

export default function Partners(props) {
  const { event } = props;

  const pending = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          response: 'Pending'
        }
      }
    },
    pagination: {
      pageSize: 1000,
      order: 'createdAt asc'
    }
  });

  const declined = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          response: 'No'
        }
      }
    },
    pagination: {
      pageSize: 1000,
      order: 'createdAt asc'
    }
  });

  const maybe = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          response: 'Maybe'
        }
      }
    },
    pagination: {
      pageSize: 1000,
      order: 'createdAt asc'
    }
  });

  const attending = useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          eventId: event.id,
          response: 'Yes'
        }
      }
    },
    pagination: {
      pageSize: 1000,
      order: 'createdAt asc'
    }
  });

  return (
    <div className="flex items-center whitespace-nowrap space-x-2">
      <Tooltip tooltip="Declined" icon={false}>
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
          {declined.data.length}
        </span>
      </Tooltip>
      <Tooltip tooltip="Pending" icon={false}>
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-cs-yellow-100 text-cs-yellow-800">
          {pending.data.length}
        </span>
      </Tooltip>
      <Tooltip tooltip="Maybe" icon={false}>
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-cs-blue-100 text-cs-blue-800">
          {maybe.data.length}
        </span>
      </Tooltip>
      <Tooltip tooltip="Attending" icon={false}>
        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
          {attending.data.length}
        </span>
      </Tooltip>
    </div>
  );
}
